import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { SiteNav } from '../components/SiteNav';
import { StarDivider } from '../components/Ornaments';
import { RealmNavigator } from '../components/realm/RealmNavigator';
import { getRealm } from '../data/realms';
import DeepRealm from './realms/DeepRealm';
import DescentRealm from './realms/DescentRealm';

const Placeholder = ({ realm }) => (
  <div className="luxury-landing min-h-screen" style={{ background: '#060E1A' }} data-testid="realm-page">
    <SiteNav interest={realm.name} />
    <main className="relative min-h-screen overflow-hidden flex flex-col items-center justify-center text-center px-6 pt-28 pb-20">
      <div className="hero-stars hero-stars--a" aria-hidden />
      <img src={realm.sigil} alt={`${realm.name} sigil`} className="portal-sigil hero-reveal" style={{ '--d': '0ms' }} />
      <p className="portal-numeral hero-reveal mt-4" style={{ '--d': '150ms' }}>Realm {realm.numeral}</p>
      <h1 className="hero-reveal text-4xl sm:text-5xl lg:text-6xl text-[#D2B47C] tracking-[0.18em] uppercase mt-4" style={{ '--d': '250ms' }} data-testid="realm-title">
        {realm.name}
      </h1>
      <p className="hero-reveal text-[#B9A98A] italic text-lg md:text-xl mt-3" style={{ '--d': '350ms' }}>{realm.subtitle}</p>
      <StarDivider className="my-8 hero-reveal" />
      <p className="hero-reveal text-[#B9A98A] text-sm md:text-base max-w-md leading-relaxed" style={{ '--d': '450ms' }}>
        This realm is being prepared for its opening. The house will unveil its artifacts here.
      </p>
      <div className="hero-reveal mt-10 flex flex-col sm:flex-row gap-4 items-center" style={{ '--d': '550ms' }}>
        <Link to="/#contact" state={{ interest: realm.name }} className="portal-enter" data-testid="realm-request-preview">Request Preview</Link>
        <Link to="/" className="nav-link" data-testid="realm-return-home">Return to the House</Link>
      </div>
    </main>
    <RealmNavigator active={realm.slug} />
  </div>
);

export default function RealmPage() {
  const { realmSlug } = useParams();
  const realm = getRealm(realmSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [realmSlug]);

  if (!realm) return <Navigate to="/" replace />;
  if (realm.slug === 'the-deep') return <DeepRealm />;
  if (realm.slug === 'the-descent') return <DescentRealm />;
  return <Placeholder realm={realm} />;
}
